/**
 * 编辑页路由
 */
"use strict";
angular.module("activityRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("activity", {
        url: "/activity?id&type",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
                    '<div class="view_body">' +
                    '<div ui-view="main"></div>' +
                    '</div>'
            },
            "header@activity": {
                templateUrl: 'header/headerDetails_tpl.html',
                controller: 'webHeaderCtrl'
            },
            "main@activity": {
                templateUrl: "./main/submissionManage/personalLibrary/activity/activity_tpl.html",
                controller: "activityCtrl"
            }
        }
    });
}]);